import { render, staticRenderFns } from "./ProductDetailComp.vue?vue&type=template&id=c25be14a"
import script from "./ProductDetailComp.vue?vue&type=script&lang=js"
export * from "./ProductDetailComp.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailComp.vue?vue&type=style&index=0&id=c25be14a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports